const NEXTJS_WEB_VITAL_LABEL = "web-vital";
const BIGBRAIN_TRACKING_URL = "https://track.bigbrain.me/prod/event";
module.exports = {
    NEXTJS_WEB_VITAL_LABEL,
    BIGBRAIN_TRACKING_URL
};
